



<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" color="#FEBD08" :timeout="timeout" app right>
      <v-layout wrap>
        <v-flex xs11>
          {{ msg }}
        </v-flex>
        <v-flex xs1>
          <v-icon @click="snackbar = !snackbar">mdi-close</v-icon>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-form ref="form">
      <v-layout wrap>
        <v-flex xs12 md6 px-2 px-md-4>
          <v-layout wrap>
            <v-flex xs12 py-5>
              <div class="RM clr">SELLER PORTAL</div>
              <div class="head" v-if="!$route.query.productId">
                Add Products
              </div>
              <div class="head" v-else>Edit Products</div>
            </v-flex>
            <v-flex xs12 class="RB">Select item type </v-flex>
            <v-flex xs12>
              <v-select
                :rules="[rules.required]"
                dense
                outlined
                class="textfd"
                v-model="itemType"
                :items="temp"
                item-text="name"
                item-value="_id"
              >
              </v-select>
            </v-flex>
            <v-flex xs12 class="RB">Honey Type </v-flex>
            <v-flex xs12>
              <v-select
                dense
                outlined
                v-model="product.honeyType"
                class="textfd"
                :items="honeyTypes"
                item-text="name"
                item-value="_id"
              >
              </v-select>
            </v-flex>
            <v-flex xs12 py-3 class="RB clr">Product Stock </v-flex>
            <v-flex xs4 md3>
              <div class="RB">Total Stock (KG)</div>
              <div>
                <v-text-field
                  type="number"
                  :rules="[rules.required]"
                  v-model="product.stockQuantity"
                  class="textfd"
                  dense
                  outlined
                >
                </v-text-field>
              </div>
            </v-flex>
            <v-flex xs4 md3 px-1 align-self-end>
              <div class="RB">Price / KG</div>
              <div>
                <v-text-field
                  type="number"
                  :rules="[rules.required]"
                  v-model="product.price"
                  class="textfd"
                  dense
                  outlined
                >
                </v-text-field>
              </div>
            </v-flex>
            <v-flex xs4 md3>
              <div class="RB">Offer Percentage</div>
              <div>
                <v-text-field
                  type="number"
                  :rules="[rules.num]"
                  v-model="product.offer"
                  class="textfd"
                  dense
                  outlined
                >
                </v-text-field>
              </div>
            </v-flex>

            <v-flex xs12 md9>
              <v-radio-group v-model="product.radio">
                <v-layout wrap>
                  <v-flex xs12 class="RB">Status </v-flex>
                  <v-flex xs3>
                    <v-radio
                      class="RB"
                      style="padding-bottom: 2%"
                      label="Active"
                      value="Active"
                      color="green"
                    ></v-radio>
                  </v-flex>
                  <v-flex xs3>
                    <v-radio
                      class="RB"
                      style="padding-bottom: 2%"
                      label="Inactive"
                      value="Inactive"
                      color="green"
                    ></v-radio>
                  </v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 class="RB clr" py-5>Add Benefits </v-flex>
            <v-flex xs12>
              <v-layout wrap>
                <v-flex>
                  <v-text-field
                    :rules="[rules.required]"
                    v-model="product.benefits"
                    outlined
                    style="border-radius: 1px"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 class="RB clr" pb-5>Add Description </v-flex>
            <v-flex xs12>
              <v-layout wrap>
                <v-flex>
                  <v-textarea
                    :rules="[rules.required]"
                    v-model="product.description"
                    outlined
                    style="border-radius: 1px"
                  >
                  </v-textarea>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 py-6 pb-lg-10 v-if="!$route.query.productId">
              <v-btn @click="addProduct" tile width="100%" color="#FEBD08"
                >ADD
              </v-btn>
            </v-flex>
            <v-flex xs12 py-6 pb-lg-10 v-if="$route.query.productId">
              <v-btn @click="editProduct" tile width="100%" color="#FEBD08"
                >EDIT
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md6>
          <v-layout wrap pt-7 pb-3>
            <v-flex xs12 pb-3 v-if="!$route.query.productId">
              <ImageComp
                @stepper="winStepper"
                :height="'888'"
                :width="'888'"
                :heading="'Upload Images'"
              />
            </v-flex>
            <v-flex xs12 pb-3 v-if="$route.query.productId">
              <ImageComp
                @stepper="winStepper"
                :photos="allPhotos"
                :pageId="product._id"
                :height="'888'"
                :width="'888'"
                :heading="'Upload Images'"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>
<script>
import axios from "axios";
import ImageComp from "./multipleImages";
export default {
  data() {
    return {
      ServerError: false,
      timeout: 5000,
      snackbar: false,
      msg: "",
      appLoading: false,
      product: {
        // itemType: null,
        honeyType: null,
        stockQuantity: "",
        price: "",
        offer: "",
        description: "",
        radio: "Active",
        benefits: "",
      },
      allPhotos: [],
      items: [],
      temp: [],
      itemType: null,

      honeyTypes: [],

      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        num: (value) => (value < 100 && value >= 0) || "Must be between 0-100",
      },

      imageArray: [],
      imageError: "",
      imageCoverError: "",
      formData: new FormData(),
      selectedFiles: [],
      image: null,

      imageFiles: [],
    };
  },
  components: {
    ImageComp,
  },
  mounted() {
    this.getItem();
  },
  watch: {
    itemType() {
      for (var i = 0; i < this.temp.length; i++) {
        if (this.itemType == this.temp[i]._id) {
          this.honeyTypes = this.temp[i].subItems;
        }
      }
    },
  },
  methods: {
    winStepper(window_data) {
      if (window_data.type == "image") {
        this.imageArray = window_data.imageArray;
        this.imageFiles.push(window_data.selectedFiles);
      } else if (window_data.type == "imageRemoval") {
        // var values = this.formData.getAll("photos");
        // values.splice(window_data.removalItem, 1);
        // this.formData.set("photos", values);
         this.imageFiles.splice(window_data.removalItem, 1);
        this.imageArray = window_data.imageArray;

      } else if (window_data.type == "frontrImage") {
        this.frontImageFile = window_data.selectedFiles;
        this.guest.photo = window_data.singleImage;
      }
      console.log("image array is=", this.imageArray);
      if (window_data.getData) this.getItem();
    },

    getFromStock() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/product/get",
        params: {
          id: this.$route.query.productId,
        },
      }).then((response) => {
        if (response.data.status) {
          this.product = response.data.data;
          this.itemType = this.product.itemId._id;
          this.product.honeyType = this.product.subItemId._id;
          this.product.radio = this.product.status;
          this.allPhotos = this.product.photos;
          this.appLoading = false;
        } else {
          console.log("failed to get the values");
        }
      });
    },

    getItem() {
      // this.appLoading =true
      axios({
        method: "GET",
        url: "/item/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.temp = response.data.data;

            for (let i = 0; i < response.data.data.length; i++) {
              this.items = response.data.data[i].name;
            }

            if (this.$route.query.productId) this.getFromStock();
            //  alert("success")
          } else {
            alert("there is no data in items");
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addProduct() {
      if (this.$refs.form.validate()) {
        this.appLoading = true;
        axios({
          method: "post",
          url: "/product/add",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          data: {
            itemId: this.itemType,
            subItemId: this.product.honeyType,
            description: this.product.description,
            stockQuantity: this.product.stockQuantity,
            price: this.product.price,
            offer: this.product.offer,
            status: this.product.radio,
            benefits: this.product.benefits,
          },
        })
          .then((response) => {
            if (response.data.status) {
              if (this.imageArray.length > 0) {
                for (var i = 0; i < this.imageFiles.length; i++)
                  this.formData.append("photos", this.imageFiles[i]);
                this.uploadMainImages(response.data.id);
              }
              this.appLoading = false;
            } else {
              this.snackbar="true";
              this.msg ="Failed to add products"
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
    uploadMainImages(item) {
      // this.appLoading = true;
      this.formData.append("id", item);
      axios({
        method: "POST",
        url: "/product/photo/upload",
        data: this.formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.$router.push("/stock");
          } else {
            this.msg = "Can't Upload Image.. Please Try Again Later";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.msg = "Can't Upload Image.. Please Try Again Later";
          this.showSnackBar = true;
          console.log(err);
        });
    },
    editProduct() {
      if (this.$refs.form.validate()) {
        axios({
          method: "post",
          url: "/product/edit",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          data: {
            id: this.$route.query.productId,
            itemId: this.itemType,
            subItemId: this.product.honeyType,
            description: this.product.description,
            stockQuantity: this.product.stockQuantity,
            price: this.product.price,
            offer: this.product.offer,
            status: this.product.radio,
            benefits: this.product.benefits,
          },
        })
          .then((response) => {
            if (response.data.status) {
              if (this.imageArray.length > 0) {
                for (var i = 0; i < this.imageFiles.length; i++)
                  this.formData.append("photos", this.imageFiles[i]);
                this.uploadMainImages(this.$route.query.productId);
              }
              this.$router.push("/stock");
              this.snackbar = true;
              this.msg = "Product updated Successfully";
            } else {
              alert("failed to add products");
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
  },
};
</script>